module.exports = {"House3":{"daobanList":[{"title":"1:广州集体户口，是否办理市内迁移","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、居民户口簿","state":"必要"},{"name":"2、居民身份证","state":"必要"},{"name":"3、出生医学证明（或亲属关系材料）","state":"必要"},{"name":"4、不动产权证书（或入户地址材料）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdh-3.json
// module id = 1259
// module chunks = 0